var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPartiallyCorrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17a16 16 0 1 0 32 0 16 16 0 0 0-32 0Z",
    fill: "#FA8C16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm3.816-5.581a.766.766 0 0 1-.298.418A.894.894 0 0 1 17 21a.894.894 0 0 1-.518-.163.766.766 0 0 1-.298-.418C12.892 8.57 13.03 9.106 13.017 8.986a3.354 3.354 0 0 1 .191-1.497c.177-.481.462-.923.837-1.298a4.012 4.012 0 0 1 1.34-.88A4.328 4.328 0 0 1 17 5c.556 0 1.106.106 1.615.31.509.206.965.505 1.34.88.375.376.66.818.837 1.3.177.48.242.99.191 1.496-.013.12.126-.418-3.167 11.433Z",
    fill: "#fff",
    stroke: "#AD4E00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17a16 16 0 1 0 32 0 16 16 0 0 0-32 0v0Z",
    stroke: "#873800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartiallyCorrect);
export default __webpack_public_path__ + "static/media/icon_partially_correct.ca575b9bbc8a41728ef61a15b4cbc0cb.svg";
export { ForwardRef as ReactComponent };